import React, { useEffect, useState } from 'react';
import { useClassName } from 'common/hooks';
import HomepageImage from 'public/screens/Home/Components/Image';
import './options-input.less';
import { Dropdown } from 'common/components';

export default function OptionsInput({ input, handleInputChange, value }) {
  const classNames = useClassName('CLPOptionsInput');
  const { options, name, type } = input.fields;
  const categories = [
    ...new Set(options.map((option) => option.fields.group).filter(Boolean)),
  ];
  const [selectedCategory, setSelectedCategory] = useState(categories[0] || '');
  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    if (!value) {
      setSelectedCategory(categories[0]);
      setSelectedValues([]);
    }
  }, [value]);

  const optionsToDisplay = !categories.length
    ? options
    : options.filter(
        (option) =>
          !option.fields.group || option.fields.group === selectedCategory
      );

  function CategoriesDropDown() {
    return (
      <Dropdown
        options={categories.map((category) => ({
          label: category,
          value: category,
        }))}
        selected={selectedCategory}
        handleChange={setSelectedCategory}
        classNames={classNames('categories-dropdown')}
      />
    );
  }

  function handleChange(e) {
    const { value, checked } = e.target;
    if (type === 'checkbox') {
      const updatedValues = checked
        ? [...selectedValues, value]
        : selectedValues.filter((v) => v !== value);
      setSelectedValues(updatedValues);
      handleInputChange({ ...input.fields, value: updatedValues });
    } else {
      handleInputChange({ ...input.fields, value });
    }
  }

  return (
    <div className={classNames('container')}>
      {Boolean(categories.length) && <CategoriesDropDown />}
      <div>
        <div className={classNames('options-container')}>
          {optionsToDisplay.map((option) => (
            <label
              key={option.fields.value}
              className={classNames([
                'option',
                `option-${option.fields.fullWidth ? 'full-width' : 'default'}`,
                `option-${
                  value === option.fields.value ||
                  (Array.isArray(value) && value?.includes(option.fields.value))
                    ? 'checked'
                    : 'unchecked'
                }`,
              ])}>
              <div className={classNames('option-value')}>
                {option.fields.asset && (
                  <div
                    className={classNames(
                      'asset-container',
                      option.fields.frameAsset && 'framed'
                    )}>
                    <HomepageImage field={option.fields.asset} />
                  </div>
                )}
                <span>{option.fields.value}</span>
              </div>
              <input
                type={type}
                name={name}
                value={option.fields.value}
                onChange={handleChange}
                checked={
                  value === option.fields.value ||
                  (Array.isArray(value) && value?.includes(option.fields.value))
                }
              />
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
